import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { authzScopeList, authzTeamDetail } from '@/features/authz/api'
import { AuthzTeamUpdateForm } from '@/features/authz/components/authz-team-form'

export const Route = createFileRoute('/_app/settings/team/$id/edit')({
	async loader({ context, params }) {
		const { qc } = context
		await Promise.all([
			qc.ensureQueryData(authzScopeList.qry()),
			qc.ensureQueryData(authzTeamDetail.qry({ id: params.id })),
		])
	},
	component: Component,
})

function Component() {
	const { id } = Route.useParams()
	const {
		data: { team },
	} = useSuspenseQuery(authzTeamDetail.qry({ id }))

	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/settings', 'Pengaturan'],
					['/settings/team', 'Team'],
					[Route.fullPath, `Edit ${team.name}`],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Edit tim" />
				<AuthzTeamUpdateForm />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
